module.exports = __webpack_public_path__ + "img/banner.df4364a3.png";